
import { Routes } from '@angular/router';
import { ApplicationListComponent } from './components/application-list/application-list.component';
import { ApplicationDetailComponent } from './components/application-detail/application-detail.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';
import { AdminComponent } from './components/admin/admin.component';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
    title: 'Login',
  },
  {
    path: '',
    redirectTo: 'applications',
    pathMatch: 'full',
  },
  {
    path: 'applications',
    component: ApplicationListComponent,
    canActivate: [authGuard],
    title: 'Onboarding Applications'
  },
  {
    path: 'applications/:id',
    component: ApplicationDetailComponent,
    canActivate: [authGuard],
    title: 'Application Details'
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [authGuard],
    title: 'User Management'
  },
  {
    path: '**',
    redirectTo: 'applications'
  }
];
